export default function tracking() {
  
  (function($){

  })(jQuery);
  
}
